import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { UpperCasePipe } from "@angular/common";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { ALTERNATIVE_PAGES } from "../../core/constants/page-content.constants";
import { SeoService } from "../../core/services/seo.service";
import { APP_NAME, APP_CONSTANTS } from "../../core/constants/app.constants";

@Component({
  selector: "app-alternative-page",
  standalone: true,
  imports: [RouterLink, UpperCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./alternative-page.component.html",
  styleUrl: "./alternative-page.component.scss",
})
export class AlternativePageComponent {
  readonly appName = APP_NAME;
  private readonly route = inject(ActivatedRoute);
  readonly slug =
    this.route.snapshot.paramMap.get("slug") ??
    this.route.snapshot.routeConfig?.path ??
    "";
  readonly page = ALTERNATIVE_PAGES[this.slug];

  constructor() {
    if (!this.page) return;
    inject(SeoService).updatePage({
      title: `${this.page.title} | ${APP_NAME}`,
      description: this.page.description,
      canonical: `${APP_CONSTANTS.siteUrl}/${this.page.slug}/`,
    });
  }
}
